import { RouteObject, createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from 'pages/AppLayout/ui/AppLayout';
import { RequireAuth } from 'features/ReuqireAuth';

import { OrdersPage } from 'pages/Orders';
import { EnginesPage } from 'pages/Engines';
import { FeedbackPage } from 'pages/Feedback';
import { UsersPage } from 'pages/Users';
import { ProfilePage } from 'pages/Profile';
import { NotFoundPage } from 'pages/NotFound/ui/NotFoundPage';
import { RegistrationPage } from 'pages/Registration';
import { SuspendedPage } from 'pages/Suspended';
import { PendingPage } from 'pages/Pending';
import { FormalizedZipPage } from 'pages/FormalizedZip';
import { UnFormalizedZipPage } from 'pages/UnFormalizedZip';

const router: RouteObject[] = [
  {
    path: '/registration',
    element: <RequireAuth><RegistrationPage /></RequireAuth>,
  },
  {
    path: '/suspended',
    element: <RequireAuth><SuspendedPage /></RequireAuth>,
  },
  {
    path: '/pending',
    element: <RequireAuth><PendingPage /></RequireAuth>,
  },
  {
    path: '/*',
    element: <RequireAuth><AppLayout /></RequireAuth>,
    children: [
      {
        index: true,
        element: <Navigate to="/engines" replace />,
      },
      {
        path: 'orders',
        children: [
          {
            index: true,
            element: <OrdersPage />,
          },
        ],
      },
      {
        path: 'engines',
        children: [
          {
            index: true,
            element: <EnginesPage />,
          },
        ],
      },
      {
        path: 'feedback',
        children: [
          {
            index: true,
            element: <FeedbackPage />,
          },
        ],
      },
      {
        path: 'formalized-zip',
        children: [
          {
            index: true,
            element: <FormalizedZipPage />,
          },
        ],
      },
      {
        path: 'unformalized-zip',
        children: [
          {
            index: true,
            element: <UnFormalizedZipPage />,
          },
        ],
      },
      {
        path: 'users',
        children: [
          {
            index: true,
            element: <UsersPage />,
          },
        ],
      },
      {
        path: 'profile',
        children: [
          {
            index: true,
            element: <ProfilePage />,
          },
        ],
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];

export const browserRouter = createBrowserRouter(router);
